export default "__VITE_ASSET__mQJ8CgrL__"